<template>
  <div class="cooperation_application" v-loading="loading">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="name" suffix-icon="el-icon-search" placeholder="请输入加盟商名称" clearable @change="onSearch"></el-input>
      <el-input class="s_input" v-model="num" suffix-icon="el-icon-search" placeholder="请输入加盟商编号" clearable @change="onSearch"></el-input>
      <el-input class="s_input" v-model="telname" suffix-icon="el-icon-search" placeholder="请输入联系人" clearable @change="onSearch"></el-input>
      <el-button type="primary" @click="handleAdd">新增</el-button>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="companyName" label="加盟商名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="companyCode" label="加盟商编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="contactMan" label="联系人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="contactTel" label="联系电话"></el-table-column>
        <el-table-column show-overflow-tooltip prop="busiLicenseUrl" label="营业执照">
          <template slot-scope="scope">
            <span @click="previewImage(scope.row.busiLicenseUrl)" class="title-img">查看图片</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="creditCode" label="统一社会信用代码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="createdTime" label="加盟时间"></el-table-column>
        <el-table-column show-overflow-tooltip label="状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.switch" active-color="#" inactive-color="#E2E2E2" @change="changeStatus(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="handleShow(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="imgList"
    ></el-image-viewer>
    <el-dialog title="新增" :visible.sync="dialogVisible" :before-close="onCancel">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="280px" class="ruleForm" label-position="right">
        <el-form-item label="营业执照照片" prop="businessLicense">
          <el-upload class="upload-demo" ref="upload" accept=".png,.jpeg,.jpg" :file-list="fileList" :limit="1" name="multipartFile" :headers="headers" :action="action" :on-success="busiLicenseSuccess" :before-upload="beforeUploads" :on-remove="handleRemove" :on-exceed="onExceed" list-type="picture">
            <el-button type="primary">点击上传</el-button>
            <div slot="tip" class="el_upload__tip">
              <i class="el-icon-warning"></i>
              <span>请确保营业执照信息清晰可见，图片格式仅支持jpg、jpeg、png，图片大小不超过5MB。</span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="加盟商名称" prop="shopName">
          <el-input v-model.trim="ruleForm.companyName" placeholder="上传营业执照自动识别" disabled></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="creditCode">
          <el-input v-model="ruleForm.creditCode" placeholder="上传营业执照自动识别" disabled></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contactMan">
          <el-input v-model="ruleForm.contactMan" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactTel">
          <el-input v-model.number="ruleForm.contactTel" type="number" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="userPassword">
          <el-input v-model="ruleForm.userPassword" placeholder="请输入登录密码"></el-input>
          <el-tooltip style="margin-left: 10px" content="密码至少8位数且必须包含大写字母、小写字母、数字" placement="top" effect="light">
            <i class="el-icon-warning-outline tips"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="确认密码" prop="userConfirmPassword">
          <el-input v-model="ruleForm.userConfirmPassword" placeholder="请再次输入登录密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      showViewer: false,
      imgList: [],
      loading: false,
      tableData: [],
      iconLoading: false,
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      headers: { token: this.$store.state.token },
      fileList: [],
      name: "",
      num: "",
      telname: "",
      ruleForm: {
        // companyName: "123", // 加盟商名称
        // businessLicense: "222", // 营业执照id
        // busiLicenseUrl: "https://img0.baidu.com/it/u=1462818562,2531016854%26fm=253%26app=53%26size=w500%26n=0%26g=0n%26f=jpeg?sec=1724313187%26t=e51e12820bfaef94a740143f1f16c4fe", // 营业执照url
        // creditCode: "21323", // 统一社会信用代码
        companyName: "", // 加盟商名称
        businessLicense: "", // 营业执照id
        busiLicenseUrl: "", // 营业执照url
        creditCode: "", // 统一社会信用代码
        contactMan: "", // 联系人
        contactTel: "", // 联系电话
        userPassword: "", // 密码
        userConfirmPassword: "", // 确认密码
      },
      rules: {
        companyName: [{ required: true, message: "缺少加盟商名称", trigger: "blur" }],
        contactMan: [{ required: true, message: "缺少联系人", trigger: "blur" }],
        businessLicense: [{ required: true, message: "缺少营业执照", trigger: "blur" }],
        creditCode: [{ required: true, message: "缺少统一社会信用代码", trigger: "blur" }],
        contactTel: [
          { required: true, message: "请输入电话号码（手机号码是登录账号）", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              // 只有在值不为空时才发起请求验证手机号是否已存在
              if (value) {
                // 快速正则匹配手机号格式
                // 校验手机号是否已被注册
                this.iconLoading = true
                this.$axios
                  .get(`${this.$api.contactTel}/${value}`)
                  .then(res => {
                    // 如果响应-1 表示该手机号已存在
                    console.log(res)
                    const { code, desc } = res
                    if (code == -1 || code == 900) {
                      callback(new Error(desc))
                    } else {
                      callback() // 手机号可以使用，通过校验
                    }
                  })
                  .catch(error => {
                    this.iconLoading = false
                    console.error("校验手机号是否存在时发生错误:", error)
                    callback(new Error(error.desc)) // 出错时也可以先通过校验，后续处理错误或给用户友好提示
                  })
              } else {
                callback() // 手机号格式不正确，不过这里仍通过校验，因为前面应该已经有关于手机号格式的规则校验
              }
            },
            trigger: "blur",
          },
        ],
        userPassword: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          {
            min: 8,
            message: "密码格式不正确",
            validator: (rule, value, callback) => {
              if (!/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(value)) {
                callback(new Error("密码必须包含大写字母、小写字母、数字"))
              } else {
                callback()
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        userConfirmPassword: [
          { required: true, message: "请再次输入登录密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.ruleForm.userPassword) {
                callback(new Error("两次输入的密码不一致!"))
              } else {
                callback()
              }
            },
            trigger: "blur",
          },
        ],
      },
      dialogVisible: false,
      submitLoding: false,
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getCompanyList()
    // console.log(this.$axios.defaults.baseURL)
  },
  methods: {
    // 图片放大
    previewImage(url) {
      this.imgList[0] = url
      this.showViewer = true
    },
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getCompanyList()
    },
    handleShow(row) {
      // 路由传参跳转
      this.$router.push({
        path: "/franchisee/list/details",
        query: {
          id: row.id,
        },
      })
    },
    handleAdd() {
      this.dialogVisible = true
    },
    onCancel() {
      this.dialogVisible = false
      this.ruleForm = {}
      this.$refs.upload.clearFiles()
    },
    // 切换状态
    changeStatus(row) {
      const originalSwitch = row.switch
      console.log(originalSwitch)
      this.$confirm(`该加盟商即将${row.switch ? "启用" : "停用"}，是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.companyStatus, {
              id: row.id,
              status: row.switch ? "1" : "9",
            })
            .then(() => {
              this.$set(row, "switch", originalSwitch)
              this.$message.success("操作成功")
              this.getCompanyList()
            })
            .catch(() => {
              this.$set(row, "switch", !originalSwitch)
              this.$message.error("操作失败")
              this.getCompanyList()
            })
        })
        .catch(() => {
          this.$set(row, "switch", !originalSwitch)
        })
    },
    //
    submitForm(ruleForm) {
      // console.log(this.ruleForm);
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.$axios
            .post(this.$api.insertCompanyClient, this.ruleForm)
            .then(res => {
              // this.selectNoticeInfoAllList();
              this.onCancel()
              this.$message({
                message: res.desc,
                type: "success",
              })
            })
            .catch(err => {
              this.$message({
                message: err.desc,
                type: "error",
              })
              this.onCancel()
            })
        }
      })
    },
    // 获取列表
    getCompanyList() {
      this.loading = true
      this.$axios
        .get(this.$api.companyList, {
          params: {
            companyCode: this.num,
            companyName: this.name,
            contactMan: this.telname,
            pageSize: this.pageSize,
            page: this.currentPage,
          },
        })
        .then(res => {
          let list = res.result.list.map(e => {
            return {
              ...e,
              switch: e.status == "1" ? true : false,
            }
          })
          this.tableData = list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.$message({ message: err.desc, type: "error" })
          this.loading = false
        })
    },
    // 删除营业执照
    handleRemove() {
      this.ruleForm.businessLicense = ""
      this.ruleForm.creditCode = ""
      this.ruleForm.companyName = ""
    },
    onExceed() {
      this.$message.error("最多只能上传一张图片，请删除后重新上传")
    },
    // 营业执照上传成功
    busiLicenseSuccess(res) {
      if (res.code == 100) {
        this.ruleForm.businessLicense = res.result.fileId
        this.ruleForm.busiLicenseUrl = res.result.fileUrl
        // 只在生产环境调用OCR文字识别
        if (process.env.NODE_ENV == "production") {
          this.busiLicenseOCR(this.ruleForm)
        }
      } else {
        this.$message({ showClose: true, message: res.desc, type: "error" })
      }
    },
    // OCR识别营业执照自动填充
    busiLicenseOCR(e) {
      if (e.busiLicenseUrl) {
        this.$axios
          .get(this.$api.getBizLicenseInfo, {
            params: {
              imgUrl: e.busiLicenseUrl,
            },
          })
          .then(res => {
            this.ruleForm.companyName = res.result.name
            this.ruleForm.creditCode = res.result.regNum
          })
          .catch(error => {
            this.handleRemove()
            this.$refs.upload.clearFiles()
            this.$message({ showClose: true, message: error.desc, type: "error" })
          })
      }
    },
    // 文件上传
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png"
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!")
      }
      return isJPG && isLt5M
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getCompanyList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getCompanyList()
    },
    // // 重置校验
    // resetForm() {
    //   // this.ruleForm = createdRuleForm();
    //   this.$refs.ruleForm.resetFields();
    // },
  },
}
</script>

<style scoped lang="scss">
.el-icon-warning {
  color: #0096ff;
  font-size: 16px;
}
.title-img {
  color: #0096ff;
  cursor: pointer;
}
.ruleForm {
  ::v-deep .el-input,
  ::v-deep .el-input__inner {
    width: 350px;
  }
}
</style>
